<template>
  <div v-if="isLoaded">
    <div class="content-body">
      <b-modal
        id="modal_form"
        ref="modal_form"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled="form.errors.any()"
        v-model="showModal"
        @ok="handleOk"
      >
        <form
          @submit.stop.prevent="handleOk"
          @keydown="form.errors.clear($event.target.name)"
        >
          <label>Unidade</label>
          <multiselect
            v-model="unidadeSelected"
            :options="this.$parent.optionsUnidade"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Pressione enter para selecionar"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('unidade_id')"
            v-if="form.errors.has('unidade_id')"
          ></b-form-feedback>
          <label>Tipo de Carga</label>
          <b-form-input
            type="text"
            placeholder="Tipo de Carga"
            v-model="form.descr"
            name="descr"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('descr')"
            v-if="form.errors.has('descr')"
          ></b-form-feedback>
          <label>CNPJ/CPF Origem</label>
          <b-form-input
            type="text"
            placeholder="CNPJ/CPF Origem"
            v-model="form.cnpj_cpf_origem"
            name="cnpj_cpf_origem"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('cnpj_cpf_origem')"
            v-if="form.errors.has('cnpj_cpf_origem')"
          ></b-form-feedback>
          <label>CNPJ/CPF Destino</label>
          <b-form-input
            type="text"
            placeholder="CNPJ/CPF Destino"
            v-model="form.cnpj_cpf_destino"
            name="cnpj_cpf_destino"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('cnpj_cpf_destino')"
            v-if="form.errors.has('cnpj_cpf_destino')"
          ></b-form-feedback>
          <label>CNPJ/CPF Redespacho</label>
          <b-form-input
            type="text"
            placeholder="CNPJ/CPF Redespacho"
            v-model="form.cnpj_cpf_redespacho"
            name="cnpj_cpf_redespacho"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('cnpj_cpf_redespacho')"
            v-if="form.errors.has('cnpj_cpf_redespacho')"
          ></b-form-feedback>

          <label>Status</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.status"
              :options="this.$parent.optionsLivStatus"
              name="status"
              stacked
              plain
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </form>
        <div slot="modal-footer" class="w-100">
          <div class="float-left">
            <spinner v-if="loading" message="Processando..."></spinner>
          </div>
          <div class="float-right">
            <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
            <b-btn @click="showModal = false" variant="secondary">
              Fechar
            </b-btn>
            <b-btn
              @click="handleOk($event)"
              variant="primary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalUfOrdem: false,
      isFullscreen: false,
      optionsLivStatus: [],
      optionsUnidade: [],
      unidadeSelected: [],
      errors_array: [],
      form: new Form({
        tpcarga_id: "",
        descr: "",
        unidade_id: "",
        cnpj_cpf_origem: "",
        cnpj_cpf_destino: "",
        cnpj_cpf_redespacho: "",
        status: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "uf_ori.cd",
          title: "UF Origem",
        },
        {
          name: "uf_des.cd",
          title: "UF Destino",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    unidadeSelected(obj) {
      this.form.unidade_id = obj.value;
    },
  },
  mounted() {
    // this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.tpcarga_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.unidadeSelected = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onEdit(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.unidadeSelected = [];
      this.item = [];
      this.errors_array = [];
      this.helpForm.reset();
      this.form.tpcarga_id = data.tpcarga_id;
      this.form.descr = data.descr;
      // this.form.unidade_id = data.status.valor;
      if(data.unidade != null) {
        this.unidadeSelected = {
          label: data.unidade.descr,
          value: data.unidade.unidade_id,
        };
      }
      this.form.cnpj_cpf_origem = data.cnpj_cpf_origem;
      this.form.cnpj_cpf_destino = data.cnpj_cpf_destino;
      this.form.cnpj_cpf_redespacho = data.cnpj_cpf_redespacho;
      this.form.status = data.status.valor;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .put("/api/tipocarga/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/tipocarga/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/tipocarga/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
